import { z } from 'zod';
import type { ValorDelegateTokenResponse } from '../../../types/ipg/valor/valor-payment.types';
import { NonEmptyStringSchema } from '../../common.schemas';

export const ValorDelegateTokenResponseSchema: z.ZodType<ValorDelegateTokenResponse> =
    z.object({
        client_token: NonEmptyStringSchema,
        validity: NonEmptyStringSchema,
        domain: NonEmptyStringSchema,
        epi: NonEmptyStringSchema,
    });
